import { useState } from 'react';
import { InterestAccountRequest, InterestRate, CurrentRates } from 'vopay';
import apiConfig from '@/services/api.config';

const { api } = apiConfig;

export default function useFetchInterestAccountRates() {
  const [fetchingInterestAccountRates, setFetchingInterestAccountRates] = useState(false);
  const [interestRates, setInterestRates] = useState<InterestRate[]>([]);

  const [currentRates, setCurrentRates] = useState<CurrentRates>({
    'short-term': '',
  });

  async function fetchInterestRates(requestParams: InterestAccountRequest) {
    try {
      setFetchingInterestAccountRates(true);
      const res = await api.fetchInterestAccountRates(requestParams);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setInterestRates(res.InterestRates);
      setCurrentRates(res.CurrentRates);

      return res;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingInterestAccountRates(false);
    }
  }

  return {
    interestRates,
    currentRates,
    fetchInterestRates,
    fetchingInterestAccountRates,
  };
}
